import React from "react";
import { Navigate } from "react-router";

import { loginService } from "../utils/login";

export const Logout = () => {
  loginService.logout();
  return (
    <Navigate
      to={{
        pathname: "/login"        
      }}
    />
  );
};
